import { useState } from "react";
import type { TaskDTO } from "@csp/shared";
import { api, errorText } from "../lib/api";
import { FileBoard } from "./FileBoard";
import { MaterialsPanel } from "./Materials";
import { extractionBlocked } from "./ExtractionPanel";

export function ExplorationPreparation({ task, onStarted }: { task: TaskDTO; onStarted: () => void }) {
  const [note, setNote] = useState(task.materialsNote);
  const [uploading, setUploading] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [files, setFiles] = useState(task.files);
  const refreshFiles = async () => {
    setUploading(true);
    try { setFiles((await api.task(task.id)).files); }
    catch (e) { setError(errorText(e)); }
    finally { setUploading(false); }
  };
  const start = async () => {
    setBusy(true); setError(null);
    try {
      await api.updateTask(task.id, { materialsNote: note.trim() });
      await api.startTask(task.id);
      onStarted();
    } catch (e) { setError(errorText(e)); }
    finally { setBusy(false); }
  };
  const pending = files.some(f => f.state !== "synced");
  const blocked = extractionBlocked(task);
  return <div className="card">
    <h2>本次探索所需文件</h2>
    <p className="muted">文件只用于本次任务；上传不会启动浏览器。</p>
    <FileBoard task={{ ...task, files }} canUpload={!busy} onChanged={() => { void refreshFiles(); onStarted(); }} />
    <details style={{ marginTop: 12 }}><summary>全部文件（表格、删除）</summary>
      <MaterialsPanel taskId={task.id} reqs={[]} files={files} canUpload={!busy} canRemove={!busy} onBusy={setUploading} onUploaded={() => { void refreshFiles(); onStarted(); }} />
    </details>
    <label className="field" style={{ marginTop: 16 }}>
      <span className="lbl">补充说明</span>
      <textarea aria-label="补充说明" value={note} maxLength={2000} disabled={busy} onChange={e => setNote(e.target.value)} placeholder="说明本次目标公司、文件用途或其他要求" />
    </label>
    <p className="muted small">确认文件与说明后点击「开始运行」。需要扫码或缺资料时会暂停等待你。</p>
    {pending && <p className="notice">有文件尚未同步完成，请重试上传或删除失败文件后继续。</p>}
    {error && <p className="notice err">{error}</p>}
    {!pending && blocked && <p className="notice">{blocked}。提取结果见下方「信息提取」。</p>}
    <button className="btn btn-primary" disabled={busy || uploading || pending || !!blocked} onClick={() => void start()}>{busy ? "处理中…" : "开始运行"}</button>
  </div>;
}
